import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { sessionStore } from 'src/store/sessionStore';

export const GuestRoute = () => {
  const { currentUser } = sessionStore();

  if (currentUser) {
    return <Navigate to="/onboarding-trainer" replace />;
  }

  return <Outlet />;
};
